import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import Sidebar from '../Sidebar'


class BlogItem extends Component {
	render() {
		return (
			<div>
				<Header
					bg="none"
					image={require('./image.jpg')}
					title={"Bunbury Central Website"}
				/>
				<div className="entry-content">
					
					<div className="container">
						<h2 className="blog-details">
								<div className="author-circle karl"></div>
								<div className="line"></div>
								<div className="title">
									Written by <strong>Karl</strong> on Nov 20 2018  //  Posted in <strong>Web Development</strong>
								</div>
						</h2>
						
						<div className="row">
							<div className="col-lg-7">
								<div className="tagline">
									Bunbury Central: Building the Website
								</div>
								
								<p><a href="https://www.bunburycentral.com.au/">www.bunburycentral.com.au</a></p>
								
								<p>I spend lots of time obsessing over small details: selecting a serif or san-serif font, ensuring a background image contrasts enough with the foreground text, figuring out how much information needs to be presented for a user to successfully navigate a website and deciding whether I should move a colour block 10px to the right, left or delete it completely. I inhabit a space between order (rules) and chaos (unbridled creativity) and I’m constantly battling to balance my work between these two opposing pillars.</p>

								<p>I’ve been slowly developing, softening, focusing and enhancing the set of built-in checklists that have driven my creative work over the past eighteen years. Passion drives me to continually push through existing boundaries and present my clients’ brands and information in ways they’d never envisage. What motivates me every day is knowing that my best work still lays ahead.</p>

								<h4>Our desire to craft amazing work by partnering with great clients was one of Moshi Moshi Marketing’s founding principles.</h4>
						
								<p>We believe in setting standards, not limits, and we’re passionate (if not completely obsessive) about our craft. It’s the Moshi Difference! The Bunbury Central Website provided a fantastic opportunity to test our creative and technical abilities. The collaborative approach applied to this project from the outset helped shape its tone and message. It scratches below the existing narrative for a deeply rich, personal and authentic experience, based around user stories to quench a thirst for rich digital content. Bunbury’s amazing street-art, which has breathed new visual appeal into our CBD, has inspired the style and direction of this website. The creative vibe is Bunbury’s fresh new twist – bold yet familiar, it’s breaking the mould without having to break away.</p>

								<h4>The Bunbury Central website is first and foremost an exceptional marketing tool for local businesses.</h4>

								<p>With everything being connected through its unique, custom-made directory, it provides business owners with a platform to promote what they do and why they do it. Developing engagement through a personal journey, it allows users to immerse themselves in exploring the diverse brands of the CBD; digital storytelling can convince people to stay a little longer and seek richer experiences in Bunbury Central.</p>

								<p>I had a vision for Bunbury Central that I conveyed from the outset. The contribution to and support for that vision from the committee and the Bunbury Geographe Chamber of Commerce and Industry has enabled us to deliver a website that hopefully sets a new benchmark, both creatively and technically, for Bunbury. The website has also been developed exceptionally well behind the scenes to allow for easy administration. The visual exposition is woven through Bianca Turri’s photography, supported by artistic video to soften the lines and the narrative. None of this would be possible if it wasn’t for the funding provided by the WA State Government through Don Punch and the City of Bunbury: thank you everybody</p>
							
								<p>Which brings me to the Bunbury Central Project Co-ordinator, Tiana – a highly professional, driven and creative individual for whom I’ve gained great respect during the developmental timeline of this project. I believe implicitly in the power of this project and what it can do for our city, the business owners and the wider community. I invite you to join me in supporting the Bunbury Central Initiative and Tiana in the months and years ahead, which will enable us all to benefit from the success stories yet to be told.</p>
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-4">
								<Sidebar />
							</div>
						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default BlogItem;


// WEBPACK FOOTER //
// ./src/Pages/Blog/BunburyCentral/index.js